import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useCallback, useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import DropBox from "../../custom/DropBox";
import ShowImage from "../../custom/ShowImage";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
import { useDispatch } from "react-redux";
import { updateLoading } from "../../../redux/features/common/commonSlice";
const imageFileTypes = ["image/png", "image/gif", "image/jpeg"];
const otherFileTypes = [".arscene", ".videofx"];

export const AddVehicleCategory = (props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (props?.bannerFormData?.id) {
      if (props.bannerImage) {
        props.setThumbanailControl({
          showError: false,
          errorMessage: "",
          showImage: props?.bannerFormData?.imageUrl ? true : false,
          imageData: { src: props?.bannerFormData?.imageUrl },
        });
      }
    }
  }, [props.show]);
  const [value, setValue] = useState(dayjs());
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const [startDate, setStartDate] = useState(new Date("2023-10-16T06:23:56"));
  const [endDate, setEndDate] = useState();
  const [startDateChanged, setStartDateChanged] = useState(false);


  const uploadFileToAWS = async (selectedFile) => {
    if (!selectedFile) return;
    dispatch(updateLoading(true));
    const params = {
      Bucket: 'supa-dev-bucket', // bucket name
      Key: `uploads/${selectedFile.name}`,
      Body: selectedFile,
      ContentType: selectedFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      const url = data.Location.replace(
        "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
        "https://d2up68x544gew2.cloudfront.net/"
      );
      dispatch(updateLoading(false));
      return { success: true, url: url }
    } catch (error) {
      console.error('Error uploading file:', error);
      return { success: false }
    }
  };


  const handleSubmit = async () => {
    if (props?.bannerFormData?.id) {
      if (
        props?.bannerFormData?.name
      ) {
        if (props?.bannerImage) {
          const isImageUploaded = await uploadFileToAWS(props.bannerImage)
          if (isImageUploaded.success) {
            props.onSubmit(isImageUploaded.url);
          } else {
            showDangerToast("Image upload failed.");
          }
        } else {
          if (props?.thumbanailControl.imageData?.src) {
            props.onSubmit(props?.thumbanailControl.imageData?.src);
          } else {
            showDangerToast("Thumbnail is required.");
          }
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    } else {
      if (
        props?.bannerFormData?.name &&
        props?.bannerImage
      ) {
        const isImageUploaded = await uploadFileToAWS(props.bannerImage)
        if (isImageUploaded.success) {
          props.onSubmit(isImageUploaded.url);
        } else {
          showDangerToast("Image upload failed.");
        }
      } else {
        showDangerToast("Please fill all required Fields.");
      }
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.map((file, index) => {
      if (imageFileTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = function (e) {
          setImages((prevState) => [
            ...prevState,
            { id: index, src: e.target.result },
          ]);
          props?.setBannerImage(file);
          props.setThumbanailControl({
            showError: false,
            errorMessage: "",
            showImage: true,
            imageData: { id: index, src: e.target.result },
          });
        };
        reader.readAsDataURL(file);

        return file;
      } else {
        props.setThumbanailControl({
          showError: true,
          errorMessage: "Only Image file is accept. ",
          showImage: false,
          imageData: [],
        });
      }
    });
  }, []);

  useEffect(() => {
    props.setThumbanailControl({
      showError: true,
      errorMessage: "",
      showImage: props?.bannerFormData?.imageUrl ? true : false,
      imageData: { src: props?.bannerFormData?.imageUrl },
    });
    props.setFilterFileControl({
      showError: true,
      errorMessage: "",
      showImage: true,
      imageData: { src: props?.bannerFormData?.imageUrl },
    });
  }, [props?.show === true]);

  const clickToRemove = () => {
    props?.setBannerImage(null)
  }


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.bannerFormData?.id ? "Update Vehicle Category" : "Add Vehicle Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-md-6">
            <Form.Control
              value={props.bannerFormData?.name}
              onChange={(e) =>
                props.setBannerFormData({
                  ...props?.bannerFormData,
                  name: e.target.value,
                })
              }
              placeholder="Name"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
            />
            {!props?.bannerFormData?.name ? (
              <label className="custom-error-label">
                Name is required*
              </label>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6">
            Upload Icon*
            <DropBox
              onDrop={onDrop}
              acceptType="image/*"
              isImage={true}
              thumbanailControl={props?.thumbanailControl}
              setThumbanailControl={props?.setThumbanailControl}
              clickToRemove={clickToRemove}
            />
            {props.thumbanailControl?.showError ? (
              <label className="custom-error-label" style={{ color: "red" }}>
                {" "}
                {props.thumbanailControl?.errorMessage}
              </label>
            ) : (
              <></>
            )}
            {props?.bannerFormData?.id ? (
              <></>
            ) : props?.bannerImage === null ? (
              <label className="custom-error-label">
                Icon is required*
              </label>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={props.onHide}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};
